import withDashboardLayout from '../../hoc/withDashboardLayout';
import { Button, Dropdown, Empty, Modal, Select, message } from 'antd';
import StarIcon from '../../assets/star-icon.png'
import { CaretDownFilled, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
// import MaterialTable from 'material-table';
// import tableIcons from '../../utils/tableIcons';
import CustomSelect from '../../components/ui/CustomSelect';
import SortIcon from '../../assets/sort.svg';
import { GetAllReviews, UpdateServiceProviderReviews } from '../../utils/api';
import Loader from '../../components/shared/Loader';
import dayjs from 'dayjs';
import { imgPath } from '../../utils/axiosInstance';
import Logo from '../../assets/logo.png';




const Reviews = () => {


    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reviews, setReviews] = useState([]);
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filter, setFilter] = useState('');
    const [modalData, setModalData] = useState({ visible: false, selectedStatus: null, review: null });


    const handleFilterChange = (value) => {
        setPage(0);
        setFilter(value);
    }


    const dropdownItems = [
        {
            label: 'Published',
            key: 0,
        },
        {
            label: 'Unpublished',
            key: 2,
        },
    ]

    // const columns = [
    //     {
    //         title: 'Id',
    //         dataIndex: 'id',
    //         // align: 'center'
    //     },
    //     {
    //         title: 'Business Name',
    //         dataIndex: 'businessName',
    //         render: (text, record) => {
    //             return (
    //                 <div className='flex items-center gap-x-3'>
    //                     <img alt={`${text}-img`} src={record?.imgUrl} className='w-6 h-6 rounded-full' />
    //                     {text}
    //                 </div>
    //             )
    //         },
    //         sorter: (a, b) => a.businessName.localeCompare(b.businessName),
    //         sortDirections: ['ascend', 'descend'],
    //     },
    //     {
    //         title: 'Rating',
    //         dataIndex: 'rating',
    //         render: (text, record) => {
    //             return (
    //                 <div className='flex items-center gap-x-2'>
    //                     <span className='pt-0.5'>{text}</span>
    //                     <img src={StarIcon} alt='rating-icon' className='w-3 h-3' />
    //                 </div>
    //             )
    //         },
    //         sorter: (a, b) => a.rating.localeCompare(b.rating),
    //         sortDirections: ['ascend', 'descend'],
    //     },
    //     {
    //         title: 'Date of Booking',
    //         dataIndex: 'bookDate',
    //         render: (text, record) => {
    //             return (
    //                 <span>{text}</span>
    //             )
    //         },
    //     },
    //     {
    //         title: 'Comment',
    //         dataIndex: 'comment',
    //         render: (text, record) => {
    //             return (
    //                 <span>{text.slice(0, 40)}...</span>
    //             )
    //         },
    //     },
    //     {
    //         title: 'Action',
    //         dataIndex: 'status',
    //         render: (text, record) => {
    //             const updatedItems = dropdownItems.map((item) => ({
    //                 ...item,
    //                 disabled: item.key === record.status,
    //             }));
    //             return (
    //                 <div className='cursor-pointer'>
    //                     <Dropdown
    //                         menu={{ items: updatedItems, onClick: (e) => handleActionModalOpen('changeStatus', e?.key, record) }}
    //                         trigger={['click']}>
    //                         <div className='flex items-center gap-x-1'>
    //                             <span className={`${record.status === 'published' ? 'text-[green]' : 'text-[#ffd95d]'}`}>
    //                                 {text}
    //                             </span>
    //                             <button className='text-[10px]' onClick={(e) => e.preventDefault()}>
    //                                 <CaretDownFilled />
    //                             </button>
    //                         </div>
    //                     </Dropdown>
    //                 </div>
    //             )
    //         }
    //     },
    // ];


    // const columns = [
    //     {
    //         title: 'Id',
    //         field: 'id',
    //         sorting: false,
    //         cellStyle: { width: '15%' }
    //     },
    //     {
    //         title: 'Business Name',
    //         field: 'businessName',
    //         cellStyle: { width: '20%' },
    //         sorting: false,
    //         render: (record) => {
    //             return (
    //                 <div className='flex items-center gap-x-3'>
    //                     <img alt={`${record.businessName}-img`} src={record?.imgUrl} className='w-6 h-6 rounded-full object-cover flex-shrink-0' />
    //                     <span>{record.businessName}</span>
    //                 </div>
    //             );
    //         },
    //     },
    //     {
    //         title: 'Rating',
    //         field: 'rating',
    //         cellStyle: { width: '10%' },
    //         sorting: false,
    //         render: (record) => {
    //             return (
    //                 <div className='flex items-center gap-x-2'>
    //                     <span className='pt-0.5'>{record.rating}</span>
    //                     <img src={StarIcon} alt='rating-icon' className='w-3 h-3' />
    //                 </div>
    //             );
    //         },
    //     },
    //     {
    //         title: 'Date of Booking',
    //         field: 'bookDate',
    //         cellStyle: { width: '20%' },
    //         sorting: false,
    //         render: (record) => {
    //             return <span>{record.bookDate}</span>;
    //         },
    //     },
    //     {
    //         title: 'Comment',
    //         field: 'comment',
    //         cellStyle: { width: '30%' },
    //         sorting: false,
    //         render: (record) => {
    //             return <span>{record.comment.slice(0, 40)}...</span>;
    //         },
    //     },
    //     {
    //         title: 'Action',
    //         field: 'status',
    //         sorting: false,
    //         align: 'right',
    //         cellStyle: { width: '5%' },
    //         render: (record) => {
    //             const updatedItems = dropdownItems.map((item) => ({
    //                 ...item,
    //                 disabled: item.key === record.status,
    //             }));
    //             return (
    //                 <div className='cursor-pointer'>
    //                     <Dropdown
    //                         menu={{ items: updatedItems, onClick: (e) => handleActionModalOpen('changeStatus', e?.key, record) }}
    //                         trigger={['click']}>
    //                         <div className='items-center flex justify-end gap-x-1'>
    //                             <span className={` font-normal ${record.status === 'Published' ? 'text-[green]' : 'text-[#ffd95d]'}`}>
    //                                 {record.status}
    //                             </span>
    //                             <button className='text-[10px]' onClick={(e) => e.preventDefault()}>
    //                                 <CaretDownFilled />
    //                             </button>
    //                         </div>
    //                     </Dropdown>
    //                 </div>
    //             );
    //         },
    //     },
    // ];




    const fetchReviews = async () => {
        let params = '';
        params += `&pageNo=${page + 1}`;
        params += `&limit=${rowsPerPage}`;
        if (filter !== '') {
            params += `&status=${filter === 'published' ? 0 : 2}`;
        }
        try {
            setLoading(true);
            const response = await GetAllReviews(params);
            if (response?.isSuccess) {
                setCount(response?.totalRecords);
                setReviews(response?.items)
                setLoading(false);
            } else {
                message.error(response?.error);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };



    const handleActionModalOpen = (action, status, review) => {
        if (action === 'changeStatus') {
            setModalData({ visible: true, selectedStatus: status, review: review });
        }
    };

    const handleModalCancel = () => {
        setModalData({ visible: false, selectedStatus: null, review: null });
    }

    const handleChangeStatusOk = async () => {
        try {
            setBtnLoading(true);
            const res = await UpdateServiceProviderReviews({ status: modalData?.selectedStatus }, modalData?.review?.id);
            setBtnLoading(false);
            if (res?.isSuccess) {
                message.success('Status updated successfully');
                fetchReviews();
                setModalData({ visible: false, selectedStatus: null, review: null });
            }
        } catch (error) {
            setBtnLoading(false);
            message.error('Error in updating status, Try again later');
        }
    }

    useEffect(() => {
        fetchReviews();
    }, [page, rowsPerPage, filter]);




    return (
        <div className='w-full h-full'>
            <div className='w-[95%] mx-auto'>

                {/* Reviews Header */}
                <div className='w-full py-4'>
                    <h2 className='font-semibold text-lg title text-[#000000]'>Reviews</h2>
                </div>

                {/* Reviews */}
                {/* Relative if table is there */}
                <div className='search-custom-space main-scroll w-full min-h-[calc(100vh-170px)] h-[380px] overflow-scroll flex flex-col gap-y-5 box-shadow rounded-2xl'>

                    {/* <div className='w-max ml-5 border rounded-md p-0.5 border-[#EBEBEB] '>
                        <Search placeholder="Searching..." onSearch={() => { }} enterButton className="w-[300px] h-[100%] " />
                    </div> */}
                    {/* <div className='custom-sortby absolute z-50 left-[284px] top-[19px]'>
                        <CustomSelect prefixIcon={SortIcon} placeholder='Sort by' onChange={(val) => handleSortChange(val)}>
                            <Select.Option value='published'>Published</Select.Option>
                            <Select.Option value='unpublished'>Unpublished</Select.Option>
                        </CustomSelect>
                    </div> */}

                    {/* <Table className='border-top' columns={columns} dataSource={dataSource} pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['5', '10', '15', '20'] }} onChange={onChange} /> */}


                    {/* <MaterialTable
                        title="Clients"
                        columns={columns}
                        icons={tableIcons}
                        options={{
                            showTitle: false,
                            draggable: false,
                            paging: true,
                            pageSize: itemsPerPage,
                            pageSizeOptions: [10, 15, 20],
                            debounceInterval: 700,
                            padding: 'desne',
                            paginationType: 'stepped',
                            searchFieldVariant: 'outlined',
                            searchFieldAlignment: 'left'
                        }}
                        // data={query => fetchData(query)}
                        data={fetchData()}
                        // actions={[
                        //     {
                        //         icon: () =>
                        //             <Select defaultValue="This Month"
                        //                 className='w-40'
                        //                 onChange={handleSelectChange}
                        //                 options={[
                        //                     {
                        //                         value: 'thismonth',
                        //                         label: 'This Month',
                        //                     },
                        //                     {
                        //                         value: 'thisyear',
                        //                         label: 'This Year',
                        //                     },
                        //                     {
                        //                         value: 'lastmonth',
                        //                         label: 'Last Month',
                        //                     },
                        //                     {
                        //                         value: 'lastyear',
                        //                         label: 'Last Month',
                        //                     },
                        //                 ]}
                        //             />,
                        //         isFreeAction: true,
                        //     }
                        // ]}
                        components={{
                            Pagination: (props) => {
                                const { page, rowsPerPage, count, onChangePage, onChangeRowsPerPage } = props;
                                return (
                                    <div className="box-shadow-pagination text-sm" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                                        <div>
                                            <div className='bottom-pagination-text'>
                                                <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page - 1)} disabled={page === 0}><LeftOutlined /></button>
                                                <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                                                <button className='disabled:opacity-50' onClick={(e) => onChangePage(e, page + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1}><RightOutlined /></button>
                                            </div>
                                        </div>
                                        <div style={{ position: 'absolute', right: '25px' }} >
                                            <span style={{ margin: '0 10px' }}>Items per page:</span>
                                            <select className='pagination-select' value={rowsPerPage} onChange={(e) => {
                                                setItemsPerPage(e.target.value);
                                                onChangeRowsPerPage(e, itemsPerPage)
                                            }}>
                                                <option value={10}>10</option>
                                                <option value={15}>15</option>
                                                <option value={20}>20</option>
                                            </select>
                                        </div>
                                    </div>
                                );
                            },
                            // OverlayLoading: () => <div style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            //     <h2>Loading....</h2>
                            // </div>
                        }}
                    /> */}


                    <section className="review-sec">
                        <div className={`w-full py-[18px] bg-white pl-6 ${loading && 'opacity-50'}`}>
                            <CustomSelect width='w-[137px]' prefixIcon={SortIcon} value={filter} onChange={(val) => handleFilterChange(val)}>
                                <Select.Option value=''>All</Select.Option>
                                <Select.Option value='published'>Published</Select.Option>
                                <Select.Option value='unpublished'>Unpublished</Select.Option>
                            </CustomSelect>
                        </div>

                        {
                            !loading ? (
                                <div>
                                    {
                                        reviews && reviews?.length > 0 ? (
                                            reviews?.map((review, index) => {
                                                const isEven = index % 2 === 0;
                                                const backgroundColorClass = isEven
                                                    ? 'bg-white'
                                                    : 'bg-primary-300';

                                                return (
                                                    <div key={review?.id} className={`w-full flex flex-col border-top py-4 px-6 gap-y-2 ${backgroundColorClass}`}>
                                                        <div className="flex justify-between">
                                                            <div className="flex gap-x-3">
                                                                <img className="w-10 h-10 rounded-full" src={review?.business_Profile?.image ? `${imgPath}${review?.business_Profile?.image}` : Logo} alt="img" />
                                                                <div className="flex flex-col w-full">
                                                                    <span className="text-black-700 text-xs">{review?.user?.name}</span>
                                                                    <span className="text-black-700 font-semibold text-[10px]">@{review?.business_Profile?.user_name}</span>
                                                                    <div className="flex items-center gap-x-1">
                                                                        <img src={StarIcon} width={16} alt="star-icon" />
                                                                        <span className="text-lightGray text-sm">{review?.rating}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='flex flex-col items-end gap-2'>
                                                                <span className='text-xs text-lightGray'>{dayjs(review?.created_at).format('DD MMM YYYY, h:mm a')}</span>
                                                                <div className={`${review.status === 0 ? 'text-[#54a43a] bg-[#f0f7ed]' : 'text-yellow-900 bg-yellow-300'} capitalize border h-9 flex items-center gap-x-1 py-1 px-4 text-sm rounded-xl font-medium cursor-pointer`}>
                                                                    <Dropdown
                                                                        menu={{
                                                                            items: dropdownItems.filter((item) => item.key !== review?.status),
                                                                            onClick: (e) => handleActionModalOpen('changeStatus', e?.key, review)
                                                                        }}
                                                                        trigger={['click']}>
                                                                        <div className='flex items-center gap-x-1'>
                                                                            <span>
                                                                                {review?.status === 0 ? 'Published' : 'Unpublished'}
                                                                            </span>
                                                                            <button className='text-[10px]'>
                                                                                <CaretDownFilled />
                                                                            </button>
                                                                        </div>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="w-full flex justify-between items-end">
                                                            <div className="w-10/12">
                                                                <p className="text-xs text-lightGray font-normal">{review?.comment}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            )) : (
                                            <div className="w-full text-center my-16 font-medium text-xl">
                                                <Empty />
                                            </div>
                                        )
                                    }
                                </div>
                            ) : (
                                <Loader height='h-[55vh]' />
                            )
                        }

                    </section>

                    <div className="box-shadow-pagination text-sm" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                        <div className='bottom-pagination-text mobile-pagination-set'>
                            <button className='disabled:opacity-50' onClick={(e) => setPage(prev => prev - 1)} disabled={page === 0 || loading}><LeftOutlined /></button>
                            <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                            <button className='disabled:opacity-50' onClick={(e) => setPage(prev => prev + 1)} disabled={page === Math.ceil(count / rowsPerPage) - 1 || loading || reviews?.length === 0}><RightOutlined /></button>
                        </div>
                        <div style={{ position: 'absolute', right: '25px' }}>
                            <span style={{ margin: '0 10px' }}>Items per page:</span>
                            <select className='pagination-select' value={rowsPerPage} onChange={(e) => {
                                setRowsPerPage(e.target.value);
                                setPage(0);
                            }}>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>
                    </div>


                    <Modal
                        centered
                        title='Confirm Status Change'
                        open={modalData.visible}
                        onCancel={!btnLoading ? handleModalCancel : undefined}
                        footer={<div>
                            <Button onClick={handleModalCancel} disabled={btnLoading}>Cancel</Button>
                            <Button type='primary' className='text-white' onClick={handleChangeStatusOk}>
                                Ok
                                {btnLoading && <span className='loader ml-2 align-middle mb-1'></span>}
                            </Button>
                        </div>}
                    >
                        {`Are you sure you want to change status to ${modalData.selectedStatus === '0' ? 'published' : 'unpublished'}?`}
                    </Modal>

                </div>
            </div>
        </div>
    )
}

export default withDashboardLayout(Reviews);